module.exports = __webpack_public_path__ + "img/logo@3x.81988c99.png";